<script setup lang="ts">
import type { ComboboxItemIndicatorProps } from "./combobox.types";
import { useComboboxItemIndicator } from "./useCombobox.ItemIndicator";

defineOptions({ name: "ComboboxItemIndicator" });

const props = withDefaults(defineProps<ComboboxItemIndicatorProps>(), {
  icon: "check",
});

const { classes } = useComboboxItemIndicator();
</script>

<template>
  <span
    part="indicator"
    exportparts="indicator-icon"
    :class="classes"
    class="e-combobox-item-indicator"
    aria-hidden="true"
  >
    <slot>
      <e-icon exportparts="base:indicator-icon" :name="props.icon" size="sm" />
    </slot>
  </span>
</template>

<style>
:host {
  display: contents;
}
</style>
